// extracted by mini-css-extract-plugin
export var dataCell = "_qd-2";
export var dataRow = "_qd-0";
export var headerRow = "_qd-1";